import { Modal, Box, Button, SpaceBetween, Icon } from '@cloudscape-design/components';

import { CI_PORTAL_URL } from 'src/contstant/commonLabels';

interface CIProjectModalProps {
  visible: boolean;
  onDismiss: () => void;
  onCreateClick?: () => void;
  locationName: string;
}

/**
 * Modal shown on audit summary page when audit score is 100%.
 * Encourages the auditor to share best practices via a CI project.
 */
function CIProjectModal({
  visible,
  onDismiss,
  onCreateClick,
  locationName,
}: CIProjectModalProps) {
  return (
    <Modal
      data-testid="ci-project-modal"
      visible={visible}
      onDismiss={onDismiss}
      header={
        <SpaceBetween direction="horizontal" size="xs">
          <Icon name="suggestions" variant="link" />
          <span>Perfect score — share your best practices</span>
        </SpaceBetween>
      }
      closeAriaLabel="Close"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              data-testid="ci-modal-dismiss-button"
              variant="link"
              onClick={onDismiss}
            >
              Maybe later
            </Button>
            <Button
              data-testid="ci-modal-create-button"
              variant="primary"
              iconName="external"
              iconAlign="left"
              href={CI_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                onCreateClick?.();
                onDismiss();
              }}
            >
              Explore CI Project
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <Box>
        Your audit scored 100%! You&apos;re encouraged to share what&apos;s working well
        at <strong>{locationName}</strong> by creating a Continuous Improvement project,
        so other sites can learn from your best practices. You can do this now or close
        this and review the summary first.
      </Box>
    </Modal>
  );
}

export default CIProjectModal;
